import React from "react";
import { useNavigate } from "react-router-dom";
import { HiOutlineTrash } from "react-icons/hi";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

import { URL, token, navigate } from "../../components/Utils";

import "../../stylesheets/DeleteClient.scss";
import { loadingAnimation } from "../../components/scripts/functions";

export const DeleteUser = ({ id, from, removeUser }) => {
  const navigate = useNavigate();

  const deleteClient = async () => {
    try {
      loadingAnimation(true);
      const resp = await fetch(`${URL}/user/subusers/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token()}`,
        },
      });

      const data = await resp.json();
      if (resp.status == 200) {
        loadingAnimation(false);
        if (from == "table") {
          removeUser();
        } else {
          navigate("/users");
        }
      }
    } catch (e) {
      loadingAnimation(false);
      //console.log(e);
    }
  };

  const submit = () => {
    confirmAlert({
      title: "Confirm to delete.",
      message: "Are you sure you want to delete this User?",
      buttons: [
        {
          label: "Yes",
          onClick: () => deleteClient(),
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
      overlayClassName: "delete-client-overlay",
      closeOnEscape: true,
      closeOnClickOutside: true,
      keyCodeForClose: [8, 32],
    });
  };

  const Button = () => {
    return <button className="delete-user-button white red-bg">Delete</button>;
  };

  return (
    <div className="container" id="delete-user" onClick={submit}>
      {from === "table" ? <HiOutlineTrash /> : <Button />}
    </div>
  );
};
